import { useEntities } from "@/hooks/useCommonQueries";
import { useFormikContext } from "formik";
import { Flex } from "@radix-ui/themes";
import SelectField from "@/components/form/SelectField";
import FilterConditionsField from "./shared/FilterConditionsField";
import { array, object, string, InferType } from "yup";

export const deleteDataValidationSchema = object({
  parameters: object({
    entity_name: string().required("Entity is required"),
    filter_conditions: array()
      .of(
        object({
          field: string().required("Field is required"),
          operator: string().required("Operator is required"),
          value: string().when("operator", {
            is: (op: string) => op !== "is_null" && op !== "is_not_null",
            then: (schema) => schema.required("Value is required"),
            otherwise: (schema) => schema.notRequired(),
          }),
        })
      )
      .min(1, "At least one filter condition is required"),
  }),
});

export type DeleteDataFormValues = InferType<typeof deleteDataValidationSchema>;

export default function DeleteDataFields() {
  const { values } = useFormikContext<DeleteDataFormValues>();
  const { data: entities } = useEntities();

  // Initialize filter conditions if they don't exist
  if (!values.parameters.filter_conditions) {
    values.parameters.filter_conditions = [];
  }

  return (
    <Flex direction="column" gap="6">
      <SelectField
        name={`parameters.entity_name`}
        label="Entity"
        required
        type="string"
      >
        {entities?.map((entity) => (
          <SelectField.Item key={entity.id} value={entity.name}>
            {entity.name}
          </SelectField.Item>
        ))}
      </SelectField>

      <FilterConditionsField
        name="parameters.filter_conditions"
        required
        entityName={values.parameters.entity_name}
      />
    </Flex>
  );
}
